import React from 'react';

export const Step5 = () => {
  return (
    <>
      FifthStep
    </>
  );
};